import React from "react";
import { HomeDeviceSelectTemplate } from "themes/application/home/components";

function HomeDeviceSelect(props) {
    return <HomeDeviceSelectTemplate {...props} />;
}

export default HomeDeviceSelect;
